<script>
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()

  export let currentpage
  export let totalPages

  /**
   * Changes the current page of the PDF based on user input and renders the new page.
   *
   * @param {Event} e - The event object from the input field.
   */
  const changePdfPageNo = (e) => {
    // Check if the entered page number is less than the total number of pages and not zero
    if (e.target.value <= totalPages && e.target.value != 0) {
      // Update the current page number with the entered value
      currentpage = Number(e.target.value)
      // Queue the rendering of the new page
      dispatch("render")
    } else {
      // If the entered page number exceeds the total number of pages
      if (e.target.value > totalPages) {
        let prevPage = currentpage

        // Set the current page number to the last page
        currentpage = totalPages

        // Queue the rendering of the last page
        if (prevPage != currentpage) dispatch("render")
      } else if (e.target.value < 1) {
        // If the entered page number is less than 1
        // Clear the current page number input
        currentpage = ""
        // Show the first page of the PDF
        // showPage(1)
        dispatch("render")
      }
    }
  }

  /**
   * Changes the current page of the PDF based on scroll input and renders the new page.
   *
   * @param {WheelEvent} e - The wheel event object.
   */
  const changePdfPageNoWhileScroll = (e) => {
    // If the scroll direction is up and the current page is less than the total pages
    if (e.deltaY < 0 && currentpage > 1) {
      // Increment the current page number
      currentpage--
      // Queue the rendering of the new page
      dispatch("render")
    }
    // If the scroll direction is down and the current page is greater than 1
    else if (e.deltaY > 0 && currentpage < totalPages) {
      // Decrement the current page number
      currentpage++
      // Queue the rendering of the new page
      dispatch("render")
    }
  }
</script>

<!-- Previous Page Button -->
<button
  on:click={() => {
    currentpage--
    dispatch("render")
  }}
  type="button"
  disabled={currentpage == 1}
  class="flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-d00 text-gray-d00 active:border-blue-500 active:bg-blue-500 active:text-white disabled:cursor-not-allowed disabled:border-gray-100 disabled:text-gray-100 dark:border-white dark:text-white active:dark:border-blue-500 disabled:dark:border-gray-500"
>
  <i class="fa-solid fa-chevron-left" />
</button>

<!-- Page Number Input Box -->
<div class="group flex h-8 w-auto items-center justify-between px-2">
  <input
    min="1"
    max={totalPages}
    bind:value={currentpage}
    type="number"
    disabled={totalPages == 1}
    class="w-auto rounded-md border border-none bg-transparent text-left font-mono font-bold text-gray-d00 focus:outline-none dark:text-white"
    on:input|stopPropagation={changePdfPageNo}
    on:wheel|preventDefault|stopPropagation={changePdfPageNoWhileScroll}
    on:paste|preventDefault
    on:blur={() => {
      if (currentpage == "") currentpage = 1
    }}
  />

  <p class="select-none text-center font-mono font-bold text-gray-200">
    /&nbsp;{totalPages}
  </p>
</div>

<!-- Next Page Button -->
<button
  on:click={() => {
    currentpage++
    dispatch("render")
  }}
  type="button"
  disabled={currentpage == totalPages}
  class="flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-d00 text-gray-d00 active:border-blue-500 active:bg-blue-500 active:text-white disabled:cursor-not-allowed disabled:border-gray-100 disabled:text-gray-100 dark:border-white dark:text-white active:dark:border-blue-500 disabled:dark:border-gray-500"
>
  <i class="fa-solid fa-chevron-right" />
</button>
